import { MDropdown } from '@Components/Base';
import { CheckCircleOutlined, MoreOutlined } from '@ant-design/icons';
import ESSFeatureRoutePath from '@Features/router/ess/ESSFeatureRoutePath.enum';
import MRFeatureRoutePath from '@Features/router/mr/MRFeatureRoutePath.enum';
import { ReactComponent as TimeLoading } from '@Icons/additional/time-loading.svg';
import { ReactComponent as ViewIcon } from '@Icons/additional/eye.svg';
import { Flex, MenuProps } from 'antd';
import { Link, generatePath } from 'react-router-dom';
import { ApprovalHistoryParams } from '../Approvals';

import styles from './ApprovalActions.module.css';

interface ApprovalListActionProps {
  taskId: string;
  requestId: number;
  requestNo: string | undefined;
  requestTypeId?: string;
  requestService?: string;
  onApprove?: () => void;
  onReject?: () => void;
  handleApprovalHistory: ({
    requestId,
    requestService,
  }: ApprovalHistoryParams) => void;
}

interface Params {
  taskId: string;
  requestId: number;
  requestTypeId?: string;
}

const ApprovalActions: React.FC<ApprovalListActionProps> = ({
  taskId,
  requestId,
  requestTypeId,
  requestService,
  onApprove,
  onReject,
  handleApprovalHistory,
}) => {
  const params: Params = {
    taskId: taskId!,
    requestId: requestId!,
    requestTypeId: requestTypeId!,
  };

  const serviceName = requestService?.toUpperCase();
  const path = generatePath(
    serviceName === 'ESS' || serviceName === 'ITREQUISITION'
      ? `ess/approvals/${ESSFeatureRoutePath.TASK_APPROVE_REQUEST}`
      : `mr/approvals/${MRFeatureRoutePath.TASK_APPROVE_REQUEST}`,
    params
  );

  const items = (): MenuProps['items'] => [
    {
      label: (
        <Flex gap={15} onClick={onApprove}>
          <CheckCircleOutlined /> <span>Approve</span>
        </Flex>
      ),
      key: '0',
    },
    {
      label: (
        <Flex gap={15} onClick={onReject}>
          <CheckCircleOutlined /> <span>Reject</span>
        </Flex>
      ),
      key: '1',
    },
    {
      label: (
        <Link to={path} title="Approve Request">
          <Flex gap={15} onClick={() => null}>
            <ViewIcon /> <span>View</span>
          </Flex>
        </Link>
      ),
      key: '2',
    },
    {
      label: (
        <Flex
          gap={15}
          onClick={() =>
            handleApprovalHistory({ requestId, requestService, requestTypeId })
          }
        >
          <TimeLoading /> <span>Approval History</span>
        </Flex>
      ),
      key: '3',
    },
  ];

  return (
    <Flex>
      <MDropdown
        className={styles.menu}
        menu={{ items: items() }}
        trigger={['click']}
      >
        <div className={styles.more}>
          <MoreOutlined />
        </div>
      </MDropdown>
    </Flex>
  );
};

export default ApprovalActions;
